<script lang="ts">
  import { Card } from '$shared/components';

  interface Props {
    screenshotUrls: string[];
    onpreview?: (url: string) => void;
  }

  let { screenshotUrls, onpreview }: Props = $props();

  let activeIndex = $state(0);

  const onClickThumbnail = (index: number): void => {
    activeIndex = index;
  };

  const onClickShowPreview = (e: Event): void => {
    e.preventDefault();
    onpreview?.(screenshotUrls[activeIndex]);
  };
</script>

<div class="preview-screenshots">
  <a href="#" class="screenshot" onclick={onClickShowPreview}>
    {#if screenshotUrls[activeIndex]}
      <img src={screenshotUrls[activeIndex]} alt="screenshot" />
    {/if}
  </a>
  {#if screenshotUrls.length > 1}
    <div class="thumbnails">
      {#each screenshotUrls as item, i}
        <button
          class="thumbnail"
          class:active={i === activeIndex}
          onclick={() => onClickThumbnail(i)}
        >
          <img src={item} alt="screenshot" />
        </button>
      {:else}
        <div class="empty">
          <Card>No Screensot Found</Card>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .screenshot {
    display: block;
  }
  .screenshot,
  .screenshot img {
    width: 100%;
  }

  .screenshot {
    height: 200px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.07);
  }
  .screenshot img {
    cursor: pointer;
  }

  .thumbnails {
    display: flex;
    align-items: center;
    margin-top: 16px;
    overflow: auto;
  }
  .thumbnails .thumbnail {
    width: 80px;
    flex-basis: 80px;
    flex-shrink: 0;
    height: 50px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid transparent;
  }

  .thumbnails .thumbnail.active {
    border-color: var(--blue);
  }

  .thumbnails .thumbnail:not(:last-child) {
    margin-right: 8px;
  }
  .thumbnails .thumbnail img {
    width: 100%;
  }
</style>
